import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isBookingsEmail(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.BOOKINGS_EMAIL && typeof label === 'string' && typeof value === 'string';
}
function _formatBookingsEmail(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatBookingsEmail(submission) {
  if (isBookingsEmail(submission)) {
    return _formatBookingsEmail(submission);
  }
  return undefined;
}
//# sourceMappingURL=bookings-email-preview.js.map